export default __webpack_public_path__ + "static/media/bg0.65a21426.jpg";